import { Accordion, AccordionSummary, AccordionDetails, Typography, Grid } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Trans, t } from '@lingui/macro'
import dayjs, { Dayjs } from 'dayjs'
import DatePickerInput from '@/components/ui/inputs/DatePickerInput'
import DailyConsultationsByMainReasonComponent from './charts/DailyConsultationByMainReasonComponent'
import DailyConsultationsByStatusComponent from './charts/DailyConsultationsByStatusComponent'
import DailyNewPatientsComponent from './charts/DailyNewPatientsComponent'

type DailySectionProps = {
  isExpanded: boolean
  onChange: (event: React.SyntheticEvent, isExpanded: boolean) => void
  selectedDate: Dayjs | null
  onDateChange: (date: Dayjs | null) => void
  dailyReasonsData: Array<{ reason: string; count: number }>
  dailyStatusData: Array<{ status: string; count: number }>
  dailyPatientsData: any
  isMobile: boolean
}

export function DailySection({
  isExpanded,
  onChange,
  selectedDate,
  onDateChange,
  dailyReasonsData,
  dailyStatusData,
  dailyPatientsData,
  isMobile,
}: DailySectionProps) {
  return (
    <Accordion
      expanded={isExpanded}
      onChange={onChange}
      TransitionProps={{ unmountOnExit: false }}
      sx={{
        '& .MuiAccordionSummary-content': {
          margin: isMobile ? '10px 0' : undefined,
        },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="daily-content" id="daily-header">
        <Typography variant="h6" sx={{ fontSize: isMobile ? '1rem' : undefined }}>
          <Trans>Daily</Trans>
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: isMobile ? 1 : 2 }}>
        <Grid container spacing={isMobile ? 2 : 3}>
          <Grid item xs={12}>
            <DatePickerInput
              label={t`Daily Statistics`}
              value={dayjs(selectedDate)}
              onChange={onDateChange}
              sx={{
                width: '100%',
                '& .MuiInputBase-input': {
                  fontSize: isMobile ? '0.875rem' : undefined,
                },
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <DailyConsultationsByMainReasonComponent
              data={dailyReasonsData}
              title={t`Main Reason`}
              date={selectedDate?.toString() || ''}
            />
          </Grid>
          <Grid item xs={12}>
            <DailyConsultationsByStatusComponent data={dailyStatusData} title={t`Status`} date={selectedDate?.toString() || ''} />
          </Grid>
          <Grid item xs={12}>
            <DailyNewPatientsComponent data={dailyPatientsData} title={t`New Patients`} />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  )
}
